import { render, staticRenderFns } from "./feedback-ope.vue?vue&type=template&id=672c6c6e&scoped=true&"
import script from "./feedback-ope.vue?vue&type=script&lang=js&"
export * from "./feedback-ope.vue?vue&type=script&lang=js&"
import style0 from "./feedback-ope.vue?vue&type=style&index=0&id=672c6c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c6c6e",
  null
  
)

export default component.exports